import React from 'react';

export const GreenCircleCheck = () => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2.25C9.48438 2.25 6.29688 4.125 4.51562 7.125C2.78125 10.1719 2.78125 13.875 4.51562 16.875C6.29688 19.9219 9.48438 21.75 13 21.75C16.4688 21.75 19.6562 19.9219 21.4375 16.875C23.1719 13.875 23.1719 10.1719 21.4375 7.125C19.6562 4.125 16.4688 2.25 13 2.25ZM13 24C8.6875 24 4.75 21.75 2.59375 18C0.4375 14.2969 0.4375 9.75 2.59375 6C4.75 2.29688 8.6875 0 13 0C17.2656 0 21.2031 2.29688 23.3594 6C25.5156 9.75 25.5156 14.2969 23.3594 18C21.2031 21.75 17.2656 24 13 24ZM18.2969 9.79688L12.2969 15.7969C11.8281 16.2656 11.125 16.2656 10.7031 15.7969L7.70312 12.7969C7.23438 12.375 7.23438 11.6719 7.70312 11.25C8.125 10.7812 8.82812 10.7812 9.29688 11.25L11.5 13.4531L16.7031 8.25C17.125 7.78125 17.8281 7.78125 18.2969 8.25C18.7188 8.67188 18.7188 9.375 18.2969 9.79688Z"
      fill="#0F9960"
    />
  </svg>
);
